<template>
  <div class="min-w-150 mx-3 mb-3">
    <!-- is building owner -->
    <b-card v-if="mandate.representant_owner_id" class="text-left shadow-sm">
      <div class="d-flex">
        <div class="d-flex align-items-center">
          <b-badge> {{ getTotalMandateTantiemesChargeGenerale(mandate.id) }} </b-badge>
          <b-badge
            v-if="getReducedMandateTantiemesChargeGenerale(mandate.id)"
            class="ml-1"
            variant="warning"
          >
            {{ getReducedMandateTantiemesChargeGenerale(mandate.id) }}</b-badge
          >
        </div>
        <div class="ml-2">
          {{ getPersonNameAndGender({ personId: mandate.representant_owner_id }) }}
        </div>
      </div>

      <div v-if="getAddressByMandate(mandate.id) != null" class="my-1">
        Adresse: {{ getAddressByMandate(mandate.id) }}
      </div>

      <appParticipantVotingRulesIndicator
        v-if="votingLimitRules.votingLimitIsActive"
        class="my-1"
        :nb-of-represented-mandates="nbOfRepresentedMandates"
        :nb-of-represented-tantiemes="nbOfRepresentedTantiemes"
      />
      <font-awesome-icon
        v-if="
          representedMandates.length == 1 &&
          !hasMandatesRepresented &&
          hasSelectedMandates.length == 0
        "
        class="icon-click color-gray-darker delete-participant-button"
        icon="trash-alt"
        @click="removeMainMandate"
      />
      <div
        class="btn btn-collapsed color-green-darker d-flex align-items-center"
        :class="visible ? null : 'collapsed'"
        :aria-expanded="visible ? 'true' : 'false'"
        aria-controls="collapse"
        @click="visible = !visible"
      >
        <span class="mr-2">LOTS</span>
        <font-awesome-icon :icon="visible ? 'chevron-circle-up' : 'chevron-circle-down'">
        </font-awesome-icon>
      </div>
      <b-collapse id="collapse" v-model="visible" class="mt-2">
        <div>
          <div v-for="(buildingLot, index) in buildingLots()" :key="index">
            <div class="d-flex justify-content-start my-1">
              <span>{{ "Lot " + buildingLot.lot }}</span>
              <span class="ml-5">{{ buildingLot.parts + " tantième" }}</span>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-card>

    <!-- is contact -->
    <b-card v-else-if="mandate.representant_contact_id" class="text-left bg-light">
      <div>
        {{
          getPersonNameAndGender({
            personId: mandate.representant_contact_id,
            personType: "contact",
          })
        }}
      </div>
      <appParticipantVotingRulesIndicator
        v-if="votingLimitRules.votingLimitIsActive"
        class="my-1"
        :nb-of-represented-mandates="nbOfRepresentedMandates"
        :nb-of-represented-tantiemes="nbOfRepresentedTantiemes"
      />
    </b-card>

    <!-- is contact select without mandate -->
    <b-card v-else-if="contact.is_selected" class="text-left bg-light">
      <div>
        {{
          getPersonNameAndGender({
            personId: contact.id,
            personType: "contact",
          })
        }}
      </div>
      <appParticipantVotingRulesIndicator
        v-if="votingLimitRules.votingLimitIsActive"
        class="my-1"
        :nb-of-represented-mandates="0"
        :nb-of-represented-tantiemes="0"
      />
      <font-awesome-icon
        v-if="hasSelectedMandates.length == 0"
        class="icon-click color-gray-darker delete-participant-button"
        icon="trash-alt"
        @click="removeMainContact"
      />
    </b-card>
  </div>
</template>

<script>
import MeetingORM from "@/store/orm-axios/models/Meeting";
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import MandateORM from "@/store/orm-axios/models/Mandate";
import ContactORM from "@/store/orm-axios/models/Contact";

import tablesMixins from "@/mixins/tables";
import meetingDetailsMixin from "@/mixins/meeting-details";

import appParticipantVotingRulesIndicator from "./MeetingRegisterParticipantVotingRulesIndicator";
import modalChangeMandateDates from "@/components/b-table-components/modals/ChangeMandateDates";

import { meetingMinutesNames } from "@/constants/meeting.js";

var uuid = require("uuid");

export default {
  components: {
    appParticipantVotingRulesIndicator,
    modalChangeMandateDates,
  },
  mixins: [tablesMixins, meetingDetailsMixin],
  props: {
    mandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isVideoCase: {
      type: Boolean,
      default: false,
    },
    isDummyVideoCase: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showModalChangeMandateDates: false,
      visible: false,
    };
  },
  computed: {
    representedMandates() {
      return this.$_.filter(this.presenceMandates, item => {
        if (this.mandate.representant_owner_id)
          return item.representant_owner_id == this.mandate.representant_owner_id;
        else if (this.mandate.representant_contact_id)
          return item.representant_contact_id == this.mandate.representant_contact_id;
      });
    },
    meeting() {
      return MeetingORM.getters("getById")(this.$route.params.id);
    },

    nbOfRepresentedMandates() {
      var nbOfRepresentedMandates = this.representedMandates.length;
      var participantIsOwner = !!this.$_.find(this.representedMandates, item => {
        return item.building_owner_id == item.representant_owner_id;
      });
      if (participantIsOwner) nbOfRepresentedMandates--;
      return nbOfRepresentedMandates;
    },
    nbOfRepresentedTantiemes() {
      return this.getMandatesTantiemesChargeGenerale(this.representedMandates, true);
    },

    hasMandatesRepresented() {
      if (!this.meeting) return false;

      var hasMandatesRepresented = this.$_.find(this.meeting.minutes, minute => {
        return (
          (minute.event == meetingMinutesNames.mandate_added &&
            (minute.representant_id == this.mandate.representant_owner_id ||
              minute.representant_id == this.mandate.representant_contact_id)) ||
          (minute.event == meetingMinutesNames.mandate_moved &&
            (minute.move_from_representant_id == this.mandate.representant_owner_id ||
              minute.move_from_representant_id == this.mandate.representant_contact_id)) ||
          (minute.event == meetingMinutesNames.mandate_left &&
            (minute.representant_id == this.mandate.representant_owner_id ||
              minute.representant_id == this.mandate.representant_contact_id))
        );
      });

      return !!hasMandatesRepresented;
    },
    hasMandatesEvents() {
      if (!this.meeting) return false;
      var hasMandatesEvents = this.$_.find(this.meeting.minutes, minute => {
        return (
          (minute.event == meetingMinutesNames.mandate_added ||
            minute.event == meetingMinutesNames.mandate_moved ||
            minute.event == meetingMinutesNames.mandate_left) &&
          minute.mandate_id == this.mandate.id
        );
      });
      return !!hasMandatesEvents;
    },
    buildingOwner() {
      let buildingOwner = BuildingOwnerORM.query()
        .where("id", this.mandate.building_owner_id)
        .first();
      return buildingOwner;
    },
    computedBuildingLots() {
      if (this.buildingOwner) {
        let buildingLots = BuildingLotORM.query()
          .where("building_id", this.buildingOwner.building_id)
          .with("building_owner_building_lots.building_owner_voting_rights")
          .get();
        return buildingLots;
      } else {
        return [];
      }
    },
    hasSelectedMandates() {
      return MandateORM.query()
        .where("meeting_id", this.meeting.id)
        .where("is_selected", true)
        .where("presence_status", null)
        .where("showed_up", 0)
        .get();
    },
  },
  methods: {
    openModalChangeMandateDates() {
      this.showModalChangeMandateDates = true;
    },
    closeModalChangeMandateDates() {
      this.showModalChangeMandateDates = false;
    },
    buildingLots() {
      let boLots = [];
      this.computedBuildingLots.forEach(buildingLot => {
        let buildingOwnerBuildingLots = buildingLot.building_owner_building_lots;
        buildingOwnerBuildingLots.forEach(buildingOwnerBuildingLot => {
          if (buildingOwnerBuildingLot.building_owner_id == this.buildingOwner.id) {
            let buildingOwnerVotingRights = buildingOwnerBuildingLot.building_owner_voting_rights;
            buildingOwnerVotingRights.forEach(buildingOwnerVotingRight => {
              boLots.push({
                lot: buildingLot.name,
                parts: buildingOwnerVotingRight.parts,
                categoryId: buildingOwnerVotingRight.voting_category_id,
                buildingLotId: buildingLot.id,
              });
            });
          }
        });
      });
      return boLots;
    },
    removeMainMandate() {
      let mainMandate = MandateORM.query().where("id", this.mandate.id).first();
      mainMandate.showed_up = 0;
      mainMandate.presence_status = null;
      mainMandate.is_selected = false;
      MandateORM.update({
        where: mainMandate.id,
        data: mainMandate,
      });

      let contact_id = mainMandate.representant_contact_id;
      let mandateRemoved = MandateORM.find(mainMandate.id);
      let minutes = this.changeMinutes(this.meeting, mandateRemoved, contact_id);

      MeetingORM.update({
        where: this.meeting.id,
        data(item) {
          item.minutes = minutes;
        },
      });
    },
    removeMainContact() {
      let self = this;
      let mainContact = ContactORM.query().where("id", this.contact.id).first();
      let minuteEventIndex = this.$_.findIndex(this.meeting.minutes, minute => {
        return minute.contact_id && minute.contact_id == mainContact.id;
      });
      if (minuteEventIndex != "-1") {
        this.meeting.minutes.splice(minuteEventIndex, 1);
        MeetingORM.update({
          where: this.meeting.id,
          data(item) {
            item.minutes = self.meeting.minutes;
          },
        });
      }
      mainContact.is_selected = false;
      ContactORM.update({
        where: mainContact.id,
        data: mainContact,
      });
      this.removeContactFromStore(mainContact.id);
    },
    removeContactFromStore(contactId) {
      // NOTE: Remove only if the contact is not existent in DB
      if (!uuid.validate(contactId)) {
        ContactORM.delete(contactId);
        this.$store.commit("meetingDetails/deleteMeetingDetailsContactsDataItem", contactId);
        this.setFreezedMeetingDetailsInMeeting(false);
      }
    },
  },
};
</script>
